/**
 * Header carrying the supplier the user is working as. The back end reads it in
 * `SupplierAccessFilter` (`SupplierPortalHttpHeaders.SupplierId`), so the two must match.
 */
export const SUPPLIER_ID_HEADER = "sp-supplier-id";

/** Local storage key of the selected supplier: the `SupplierInfoDto` returned by `GetSupplierInfo`. */
export const CURRENT_SUPPLIER_STORAGE_KEY = "currentSupplier";

/** Local storage key of the selected supplier as a dropdown option (`{ label, value }`), read by the header form. */
export const SUPPLIER_OPTION_STORAGE_KEY = "supplier";

/** Window event the header form (`Shesha/header-public-portal`) dispatches after the user switches supplier. */
export const SUPPLIER_CHANGED_EVENT = "sp:supplier-changed";
